import React, { useRef, useEffect, useState } from 'react';

import './assets/chat.css';
import { useAppSelector } from 'redux/hooks';
import iconClose from 'assets/icons/commons/icon_close.svg';
import {ReactComponent as IconChat} from 'assets/icons/commons/chat.svg';
import styles from './ChatComponent.module.scss';
import { ComponentsLoader } from 'components';

const ChatComponent = ({ chatOpened, setChatOpened }) => {
  const [initialized, setInitialized] = useState(false);

  const chatWrapper = useRef(null);
  const wrapper = useRef(null);

  const { userData, userInfo, currentSellerData, currentLanguage } = useAppSelector(
    ({ users, sellers, appOptions }) => ({
      userInfo: users.currentUser.info,
      userData: users.currentUser.data,
      currentSellerData: sellers.currentSeller.info.data,
      currentLanguage: appOptions.language.current,
    }),
  );

  const chatInitialize = ({ name, email, sellerName, currentLanguage, teamWoxId }) => {
    window.Chat.init(chatWrapper.current, {
      url: 'https://team.seo.group/',
      files: '/chat/',
      group: 'Sales SM_ru',
      name: name,
      email: email,
      company: sellerName,
      topic: "1. Я действующий клиент",
      digital_signature: teamWoxId || email,
      language: currentLanguage === 'ru-RU' ? 'ru' : currentLanguage === 'en-US' ? 'en' : currentLanguage,
      autologin: true,
    });
  };

  useEffect(() => {
    if (
      userData.name &&
      userData.email &&
      currentSellerData?.sellerName &&
      currentLanguage &&
      !initialized &&
      chatOpened
    ) {
      chatInitialize({
        name: userData.name,
        email: userData.email,
        sellerName: currentSellerData.sellerName,
        currentLanguage: currentLanguage,
        teamWoxId: userInfo.supportID
      });
      setInitialized(true);
    }
  }, [userInfo, userData, currentSellerData, chatOpened]);

  const closeChatHandler = () => {
    setChatOpened(false);
  };

  return (
    <>
      <div
          ref={chatWrapper}
          className={`${styles.chatWrapper} ${chatOpened ? styles.chatWrapperOpened : ''} chat`}>
          <div className={styles.closeIcon__wrapper}>
            {initialized ? (
              <button className={styles.closeIcon} onClick={closeChatHandler}>
                <img loading="lazy" src={iconClose} alt="close" className="w-[10px]" />
              </button>
            ) : (
              <div className="h-[450px] w-full flex items-center justify-center h-full">
                <ComponentsLoader />
              </div>
            )}
          </div>
        </div>
    </>
  );
};

export default ChatComponent;
